import { useContextMenu } from 'components/common/context-menu-manager';
import { useEffect } from 'react';

export default function useCloseContextMenuOnDragging(isDragging: boolean) {
  const { closeContextMenu } = useContextMenu();

  useEffect(() => {
    if (isDragging) {
      closeContextMenu();
    }
  }, [isDragging, closeContextMenu]);
}
